export default function Spinner({ message = "Loading…" }) {
  return (
    <div className="spinner-wrap" role="status" aria-live="polite">
      <div className="spinner" aria-hidden="true" />
      {message && <p className="spinner-msg">{message}</p>}
    </div>
  );
}
